/**
 * Formatea un porcentaje con dos decimales fijos y separador es-AR: `6,29 %`
 * se escribe `formatPercent(6.2857)` → `"6,29"`.
 *
 * Existe porque interpolar el número pelado (`{pct}%`) usa el formato por
 * defecto de JS: punto decimal en vez de coma, y sin decimales cuando son
 * ceros (`8%`, `7.5%`). En una caja donde todos los importes van con
 * `formatPrice` (es-AR, 2 decimales), el porcentaje quedaba con otra pinta.
 */
export const formatPercent = (
  value: number,
  locale: string = "es-AR",
): string => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0,00";
  if (typeof Intl?.NumberFormat !== "function") return n.toFixed(2);
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
};
